import * as React from "react";
import { useState } from "react";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getFilterNames } from "../../Services/AllAllotments";
import cssClasses from "./FileManager.module.css";
import { debounce, orderBy } from "lodash";
import { Box } from "@mui/system";
import { IconButton, Modal, Tab } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../Subcomponents/Button";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useRef } from "react";
import { useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MultiSelectDropDown from "../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown";
import DateComponent from "../../Subcomponents/DateComponent";
import {
  getProjectCollateralWithCpList,
  getProjectCollateralWithSalesList,
} from "../../Services/Project";

const SelectManagerModal = ({
  open,
  handleClose,
  selectedFile,
  submitHandler,
  mainProjectShare = false,
}) => {
  const searchValue = useRef("");
  const [tabLabel, setTabLabel] = useState("CP");
  const [sm, setSm] = useState([]);
  const [cp, setCp] = useState([]);
  const [selectedCp, setSelectedCp] = useState([]);
  const [selectedSm, setSelectedSm] = useState([]);
  const [step, setStep] = useState(0);
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);

  const fetchData = async () => {
    const smList = [];
    const cpList = [];
    presentLoader();
    const data1 = await getFilterNames("Users");
    const data2 = await getFilterNames("CP");
    const alreadySelectedCp = await getProjectCollateralWithCpList();
    const alreadySelectedSales = await getProjectCollateralWithSalesList();
    dismissLoader();

    data2?.data?.map((item) => {
      cpList.push({
        id: item.cpId,
        name: item.billingName,
        filter: "CP",
      });
    });
    const uniqCpList = [];
    const uniqSalesList = [];

    cpList.forEach((val) => {
      const index = alreadySelectedCp.findIndex(
        (i) =>
          i.cpId === val?.id &&
          (mainProjectShare
            ? i.projectCollateralId === selectedFile[0]?.projectCollateralId
            : i.projectCollateralId === selectedFile?.projectCollateralId)
      );
      if (index === -1) {
        uniqCpList.push(val);
      }
    });

    const sortedCp = orderBy(
      uniqCpList,
      [(cp) => cp.name.toLowerCase()],
      ["asc"]
    );
    setCp(sortedCp);

    data1?.data?.map((item) => {
      (item?.isCrmUser === null || item?.isCrmUser === false) &&
        smList.push({
          id: item.userId,
          name: item.name,
          filter: "Users",
        });
    });

    smList.forEach((val) => {
      const index = alreadySelectedSales.findIndex(
        (i) =>
          i.userId === val?.id &&
          (mainProjectShare
            ? i.projectCollateralId === selectedFile[0]?.projectCollateralId
            : i.projectCollateralId === selectedFile?.projectCollateralId)
      );
      if (index === -1) {
        uniqSalesList.push(val);
      }
    });

    const sortedSales = orderBy(
      uniqSalesList,
      [(user) => user.name.toLowerCase()],
      ["asc"]
    );
    setSm(sortedSales);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e, newValue) => {
    setTabLabel(newValue);
  };

  const debouncedFetchSearchData = debounce((e) => {
    searchValue.current = e.target.value;
  }, 800);

  const handleDeleteFromList = (value) => {
    if (value?.filter === "CP") {
      const payload = [...selectedCp];
      const index = selectedCp.findIndex((val) => val.id === value.id);
      payload.splice(index, 1);
      setSelectedCp(payload);
    } else {
      const payload = [...selectedSm];
      const index = selectedSm.findIndex((val) => val.id === value.id);
      payload.splice(index, 1);
      setSelectedSm(payload);
    }
  };

  const handleSearch = async () => {
    if (tabLabel === "CP") {
      const cpList = [];
      presentLoader();
      const data2 = await getFilterNames("CP");
      dismissLoader();

      data2?.data?.map((item) => {
        cpList.push({
          id: item.cpId,
          name: item.billingName,
          filter: "CP",
        });
      });
      const sortedCp = orderBy(
        cpList,
        [(cp) => cp.name.toLowerCase()],
        ["asc"]
      );
      if (searchValue.current === "") {
        setCp(sortedCp);
      } else {
        setCp(
          sortedCp.filter((f) =>
            searchValue.current
              ? f?.name
                  ?.toLowerCase()
                  ?.includes(searchValue.current?.toLowerCase())
              : true
          )
        );
      }
    } else {
      const smList = [];
      presentLoader();
      const data1 = await getFilterNames("Users");
      dismissLoader();

      data1?.data?.map((item) => {
        (item?.isCrmUser === null || item?.isCrmUser === false) &&
          smList.push({
            id: item.userId,
            name: item.name,
            filter: "Users",
          });
      });

      const sortedSales = orderBy(
        smList,
        [(user) => user.name.toLowerCase()],
        ["asc"]
      );
      if (searchValue.current === "") {
        setSm(sortedSales);
      } else {
        setSm(
          sortedSales.filter((f) =>
            searchValue.current
              ? f?.name
                  ?.toLowerCase()
                  ?.includes(searchValue.current?.toLowerCase())
              : true
          )
        );
      }
    }
  };

  const handleSubmit = () => {
    const cpId = [];
    const smId = [];

    selectedCp?.forEach((val) => cpId.push(val?.id));
    selectedSm?.forEach((val) => smId.push(val?.id));
    if (step === 0) {
      setStep(1);
    } else {
      submitHandler([...cpId], [...smId], selectedFile, selectDates);
    }
  };


  console.log("cp====>",cp)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <h1>
            {step === 1 && (
              <ArrowBackIcon
                sx={{ transform: "scale(1.5)", cursor: "pointer" }}
                onClick={() => setStep(0)}
              />
            )}
            <span style={{ fontSize: "20px" }}>Share {selectedFile?.name}</span>
          </h1>
          <IconButton className={cssClasses.crossButton} onClick={handleClose}>
            {" "}
            <CloseIcon />{" "}
          </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          <div className={cssClasses.tabsWrapper} style={{ height: "100%" }}>
            {step === 0 && (
              <Box className={cssClasses.listWrapper}>
                <div>
                  <TabContext value={tabLabel}>
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: "rgba(234, 236, 240, 1)",
                      }}
                    >
                      <TabList onChange={handleChange}>
                        <Tab
                          label="CP"
                          value="CP"
                          sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                        />
                        <Tab
                          label="Sales"
                          value="Sales"
                          sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                        />
                      </TabList>
                    </Box>
                    <TabPanel value="CP">
                      <div className={cssClasses.selectShareContainer}>
                        <p style={{ fontSize: "1.6rem" }}>Select CP</p>
                        <MultiSelectDropDown
                          list={cp}
                          value={selectedCp}
                          handleChange={(e) => {
                            const value = e?.target?.value;
                            if (value !== "") {
                              if (value[value.length - 1] === "all") {
                                setSelectedCp(
                                  selectedCp.length === cp.length ? [] : cp
                                );
                                return;
                              }
                              setSelectedCp(value);
                            }
                          }}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel value="Sales">
                      <div className={cssClasses.selectShareContainer}>
                        <p style={{ fontSize: "1.6rem" }}>Select SM</p>
                        <MultiSelectDropDown
                          list={sm}
                          value={selectedSm}
                          handleChange={(e) => {
                            const value = e?.target?.value;
                            if (value !== "") {
                              if (value[value.length - 1] === "all") {
                                setSelectedSm(
                                  selectedSm.length === sm.length ? [] : sm
                                );
                                return;
                              }
                              setSelectedSm(value);
                            }
                          }}
                        />
                      </div>
                    </TabPanel>
                  </TabContext>
                </div>
              </Box>
            )}
            {step === 1 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <span style={{ fontSize: "12px" }}>Link Activation Time</span>
                <Box className={cssClasses.listWrapper}>
                  <div>
                    <div className={cssClasses.dateTimeWrapper}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        <DateComponent
                          minDate={"1 Jan"}
                          maxDate={new Date()}
                          value={selectDates[0].value}
                          helperText={helperText?.startDate}
                          onChangeDate={(value) => {
                            setSelectDates((pre) => {
                              pre[0].value = value;
                              return { ...pre };
                            });
                            setHelperText((pre) => {
                              pre.endDate = "";
                              return { ...pre };
                            });
                          }}
                        />
                        <span style={{ color: "rgba(102, 112, 133, 1)" }}>
                          Start Date
                        </span>
                      </div>
                      <span style={{ color: "rgba(102, 112, 133, 1)" }}>
                        {" "}
                        __
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        <DateComponent
                          minDate={"1 Jan"}
                          disabled={selectDates[0]?.value === ""}
                          value={selectDates[1].value}
                          helperText={helperText?.endDate}
                          onChangeDate={(value) => {
                            if (selectDates[0].value === "") {
                              setHelperText((pre) => {
                                pre.endDate = "Please select start date first";
                                return { ...pre };
                              });
                            } else {
                              if (selectDates[0].value > value) {
                                setHelperText((pre) => {
                                  pre.endDate =
                                    "Select End Date Greater than start Date";
                                  return { ...pre };
                                });
                              } else {
                                setSelectDates((pre) => {
                                  pre[1].value = value;
                                  return { ...pre };
                                });
                                setHelperText((pre) => {
                                  pre.endDate = "";
                                  return { ...pre };
                                });
                              }
                            }
                          }}
                        />
                        <span style={{ color: "rgba(102, 112, 133, 1)" }}>
                          End Date
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
              </div>
            )}
          </div>
        </div>
        <div
          className={cssClasses.footer}
          style={{
            justifyContent: `${
              selectedCp?.length > 0 || selectedSm?.length > 0
                ? "space-between"
                : "flex-end"
            }`,
            gap: "2rem",
          }}
        >
          {(selectedCp?.length > 0 || selectedSm?.length > 0) && (
            <div className={cssClasses.selectedListContainer}>
              {[...selectedCp, ...selectedSm].map((v) => {
                return (
                  <div className={cssClasses.selectedList}>
                    {v.name}
                    <CloseIcon
                      style={{ fontSize: "2rem", cursor: "pointer" }}
                      onClick={() => handleDeleteFromList(v)}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {step === 0 && (
            <div>
              <Button
                padding={"7px 27px"}
                style={{
                  color: "#000",
                  backgroundColor: "#fff",
                  border: "1px solid rgba(208, 213, 221, 1)",
                }}
                btnName={"NEXT"}
                clicked={() => {
                  handleSubmit();
                }}
                disable={
                  step === 0 &&
                  selectedCp?.length === 0 &&
                  selectedSm?.length === 0
                }
              />
            </div>
          )}
        </div>
        {step === 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "15px",
            }}
          >
            <div style={{ width: "133px" }}>
              <Button
                style={{
                  color: "rgba(52, 64, 84, 1)",
                  backgroundColor: "#fff",
                  border: "1px solid rgba(208, 213, 221, 1)",
                }}
                btnName={"Copy Link"}
                clicked={() => {
                  handleSubmit();
                }}
              />
            </div>
            <div style={{ width: "90px" }}>
              <Button
                style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
                btnName={"Share"}
                clicked={() => {
                  handleSubmit();
                }}
                disable={
                  selectDates[0]?.value === "" && selectDates[1]?.value === ""
                }
              />
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default SelectManagerModal;
